export const GET_AUDITLOGS = "GET_AUDITLOGS";
export const UPDATE_AUDIT_QUERY = "UPDATE_AUDIT_QUERY";
export const GET_AUDIT_DETAIL = "GET_AUDIT_DETAIL";
export const GET_AUDIT_FILTERS = "GET_AUDIT_FILTERS";
export const EXPORT_AUDIT_DATA = "EXPORT_AUDIT_DATA";